/* Native scrolling keeps every product link reachable, with no duplicate cards. */
if (!customElements.get('camino-goods-conveyor')) {
  customElements.define('camino-goods-conveyor', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const rail = this.querySelector('.cc-conveyor-window');
      const preference = matchMedia('(prefers-reduced-motion: reduce)');
      let focused = false, visible = false, holdUntil = 0;
      let direction = 1, last = 0, position = rail.scrollLeft;
      rail.addEventListener('focusin', () => { focused = true; }, options);
      rail.addEventListener('focusout', e => { focused = rail.contains(e.relatedTarget); }, options);
      const stop = () => { holdUntil = performance.now() + 1500; };
      rail.addEventListener('pointerdown', stop, options);
      rail.addEventListener('wheel', stop, { ...options, passive: true });
      rail.addEventListener('keydown', stop, options);
      this.observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; });
      this.observer.observe(this);
      const tick = now => {
        const dt = Math.min(now - (last || now), 50); last = now;
        const max = rail.scrollWidth - rail.clientWidth;
        if (now >= holdUntil && !focused && visible && !document.hidden && !preference.matches && !window.Shopify?.designMode && max > 1) {
          position = Math.max(0, Math.min(max, position + direction * dt * 0.022));
          rail.scrollLeft = position;
          if (position >= max) direction = -1;
          if (position <= 0) direction = 1;
        } else position = rail.scrollLeft;
        this.frame = requestAnimationFrame(tick);
      };
      this.frame = requestAnimationFrame(tick);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.abort?.abort();
      this.observer?.disconnect();
    }
  });
}
